module.exports = "/_next/static/images/bl-8458b5781c1484ba0e8ea53405a7f9ff.svg";